// extracted by mini-css-extract-plugin
export default {"stack":"FatigueReplacementStep_stack__YAkN7","replacementBox":"FatigueReplacementStep_replacementBox__VEoB-"};